import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest, HttpParams} from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CuratorService {

  projectId: string;
  header;
  constructor(public http: HttpClient) {
    this.projectId = localStorage.getItem('projectId');
    this.header = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
  }

  getUserDetails(userId, pId) {
    return this.http.get(environment.app.SERVER__URL + 'project/getUserDetails/userId/'+ userId + '/projectId/' + pId);
  }

  setReleased(sourceName, proj) {
    let body = {
      sourceDB : sourceName,
      destDB : proj.value,
      destProjectId : proj.id
    };
    return this.http.post(environment.app.SERVER__URL + 'release/projectId/' + this.projectId, body, this.header);
  }

  downloadTemplate() {
    return this.http.get(environment.app.SERVER__URL + 'import/downloadTemplate/projectId/'+ this.projectId);
  }

  uploadFiles(formData) {
    return this.http.post(environment.app.SERVER__URL + 'import/uploadFiles/projectId/'+ this.projectId, formData);
  }

  downloadErrorLogs(fileType) {
    return this.http.get(environment.app.SERVER__URL + 'import/downloadErrorLog/projectId/'+ this.projectId + '/logFile/' +
      fileType, {responseType: 'blob'});
  }

  updatePassword(data) {
    return this.http.post(environment.app.SERVER__URL + 'user/changepassword', data, this.header);
  }

}
